// extracted by mini-css-extract-plugin
module.exports = {"container":"LoadingMessage_container__SqnLo","text":"LoadingMessage_text__EKc2M"};